import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { ButtonSecondary } from '~shared/ui/atoms/Buttons/ButtonSecondary';
import { MqTablet } from '~theme/media';

export const StyledResultModalWrapper = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	max-width: 80rem;
	flex-direction: column;
	align-items: center;
	align-self: center;
	justify-content: center;
	padding: 4rem 3rem;
	border-radius: var(--radius-l);
	margin-right: auto;
	margin-left: auto;
	background: var(--color-grey-10-solid);
	gap: var(--gap-x8);

	${MqTablet} {
		padding: 4rem 9rem;
	}

	&.exit {
		max-width: 42rem;
	}
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	width: 100%;
	max-width: 30rem;
	flex-direction: column;
	gap: var(--gap-x4);
`;

export const PublicButton = styled(ButtonSecondary)`
	justify-content: left;
`;

export const DecisionWrapper = styled.div`
	display: flex;
	width: 100%;
	gap: var(--gap-x4);
`;

export const VariantsWrapper = styled.div`
	display: flex;
	width: 100%;
	gap: var(--gap-x6);

	&::before,
	&::after {
		flex: 0 0 3rem;
		content: '';
	}

	${MqTablet} {
		justify-content: center;
	}
`;

export const Variants = styled.div`
	overflow: auto;
	width: calc(100% + 6rem);
	padding: 1rem 0;

	${MqTablet} {
		width: calc(100% + 18rem);
	}
`;

export const styledCard = css`
	width: 25rem;

	& svg {
		z-index: 1;
	}

	& img {
		object-fit: cover;
		transform: scale(1.5) translateY(6rem);
	}
`;
